'use client';
import { useCartStore } from '@/store/cartStore';

const CartBadge: React.FC = () => {
  const totalQuantity = useCartStore((state) => state.totalQuantity);

  if (totalQuantity === 0) {
    return null;
  }

  return (
    <div data-component-id="src/components/common/CartBadge.tsx:12:4" data-component-path="src/components/common/CartBadge.tsx" data-component-line="12" data-component-end-line="14" data-component-file="CartBadge.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20-top-2%20-right-2%20bg-red-500%20text-white%20text-xs%20rounded-full%20h-5%20w-5%20flex%20items-center%20justify-center%20font-bold%22%7D" className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold">
      {totalQuantity > 99 ? '99+' : totalQuantity}
    </div>
  );
};

export default CartBadge;
